import React from "react";

export const MemoComponent = (WrappedComponent) => {
  const MemoisedComponent = React.memo(WrappedComponent);

  return (props) => {
    return <MemoisedComponent {...props} />;
  };
};
